import './App.css';
import './style/index.css';
import { BrowserRouter, Routes, Switch, Route } from "react-router-dom";
// import home from "./home/index.jsx";
import Home from "./Home";
import Gallery from "./Gallery"
import Register from './Registration';
import RegisterVolunteer from './Registration/Volunteer';
import EventsPage from './EventsPage';

import EventHome from './NewEvent';
import NewEvent from './NewEvent/NewEvent';
import LoginPage from './auth';
import Notification from './Components/Notification';
import { useRecoilState, useRecoilValue } from 'recoil';
import { defaultToaster, toaster, userSession } from './Recoil/ActiveEvents';
import UserView from './ViewRegistrations';

function App() {
  // const [showNotification,setShowNotification] = useRecoilState(userSession);
  const showNotification = useRecoilValue(toaster);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/galllery" element={<Gallery />} />
            <Route path="/registration/:id" element={<Register />} />
            <Route path="/registration" element={<Register />} />
            <Route path="/volunteer-registration" element={<RegisterVolunteer />} />
            <Route path="/admin" element={<EventHome />} />
            <Route path="/createEvent" element={<NewEvent />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/userView" element={<UserView />} />
            {/* <Route path="*" element={<NoPage />} />  */}
          {/* </Route> */}
        </Routes>
      </BrowserRouter>

      {!!showNotification && showNotification.showPopup && (
        <Notification
          message="This is a default notification!"
          isShown={showNotification}
          // onClose={() => updateToster(false)}
        />
      )}
    </div>
  );
}

export default App;
